export const INVALID_STATUS_CHANGE = 'INVALID_STATUS_CHANGE'
export const DISPATCHER_NOT_FOUND = 'DISPATCHER_NOT_FOUND'
export const FORWARDER_NOT_FOUND = 'FORWARDER_NOT_FOUND'
export const INVALID_DELIVERY_POINTS = 'INVALID_DELIVERY_POINTS'
export const INVALID_DELIVERY_METHOD = 'INVALID_DELIVERY_METHOD'
export const USERNAME_CONFLICT = 'USERNAME_CONFLICT'
export const MISSING_OR_INACTIVE_POLICY = 'MISSING_OR_INACTIVE_POLICY'
export const CARRIER_VERIFICATION_REQUIRED = 'CARRIER_VERIFICATION_REQUIRED'
export const CANNOT_DELETE_INVOICED_TRANSACTION = 'CANNOT_DELETE_INVOICED_TRANSACTION'
export const CANNOT_DELETE_SUBORDER_INVOICED_TRANSACTION = 'CANNOT_DELETE_SUBORDER_INVOICED_TRANSACTION'
